import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=2e61508e&scoped=true"
import script from "./WalletInfo.vue?vue&type=script&lang=js"
export * from "./WalletInfo.vue?vue&type=script&lang=js"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=2e61508e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61508e",
  null
  
)

export default component.exports